import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { LORAX } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import { getProductNameTextFromApiName } from 'ui-addon-upgrades/_core/common/adapters/getProductNameText';
export const HubProductHeader = ({
  apiName
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: "align-center m-bottom-2",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "upgrade",
      size: 20,
      className: "m-right-2",
      color: LORAX
    }), /*#__PURE__*/_jsx("p", {
      className: "m-bottom-0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ebxInterstitialPage.upgradeToProduct",
        options: {
          productTitle: getProductNameTextFromApiName(apiName)
        }
      })
    })]
  });
};